import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Divider from "@material-ui/core/Divider";

import { useStyles } from "../../../../Components/CSS/TableStyle.css";
import AdminHeader from "../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomTableHead from "../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import PageTitle from "../../../../Components/PageTitle/PageTitle";
import CustomEmptyMessage from "../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import RoleBody from "../RoleBody/RoleBody";
import { url } from "../../../../Config/Config";
import Axios from "axios";
import { connect } from "react-redux";
import AddRole from "../AddRole/AddRole";
import RoleFilter from "../RoleFilter/RoleFilter";
import { getAdminRefreshToken } from "../../../../Redux/Actions/actions";
import CustomSiteLoader from "../../../../Components/CustomSiteLoader/CustomSiteLoader";
import CustomBreadCrumbs from "../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewRole extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 5,
      page: 0,
      search: {
        role: "",
      },
      isEmpty: false,
      column: [
        { name: "S.N." },
        { name: "Username" },
        { name: "Role" },
        { name: "Actions" },
      ],
      users: [],
    };
  }

  componentDidMount() {
    this.getUsers();
  }

  getUsers = async () => {
    try {
      const response = await Axios.get(`${url}/api/admin/user`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.length !== 0) {
        this.setState({
          users: response.data,
          isEmpty: false,
        });
      } else {
        this.setState({ users: [], isEmpty: true });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getUsers();
      }
    }
  };

  handleSearch = (e) => {
    this.setState({
      search: {
        ...this.state.search,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    const filtered = this.state.users.filter((user) => {
      return (
        user.role
          .toLowerCase()
          .indexOf(this.state.search.role.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="User Roles" refreshUrl={this.props.match.url} />

          <AddRole getUsers={this.getUsers} />
          <br />
          <Divider />
          <br />

          {this.state.users.length !== 0 && (
            <RoleFilter
              data={this.state.search}
              handleSearch={this.handleSearch}
            />
          )}

          <div style={{ fontSize: 20, fontWeight: "bold" }}>User Role List</div>
          {this.state.users.length !== 0 ? (
            <TableContainer>
              <Table>
                <CustomTableHead column={this.state.column} />

                <TableBody>
                  {(rowsPerPage > 0
                    ? filtered.slice(
                        rowsPerPage * page,
                        rowsPerPage * page + rowsPerPage
                      )
                    : filtered
                  ).map((role, index) => (
                    <RoleBody
                      data={role}
                      key={index}
                      index={index}
                      getUsers={this.getUsers}
                    />
                  ))}
                </TableBody>

                <CustomTableFooter
                  count={filtered.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handlePage}
                  onChangeRowsPerPage={this.handleRowsPerPage}
                />
              </Table>
            </TableContainer>
          ) : this.state.isEmpty ? (
            <CustomEmptyMessage />
          ) : (
            <CustomSiteLoader />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(ViewRole));
